import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import HomeAgent from './HomeAgent';
import HomeExhibitor from './HomeExhibitor';

const HomeUser = ({ archive = false }) => {
	const user = useSelector(state => state.auth.user);

	return (
		<div>
			{user.role === 'root' && <Navigate replace to='/cabinet'/>}
			{user.role === 'admin' && <Navigate replace to='/cabinet'/>}
			{user.role === 'agent' && <HomeAgent user={user} archive={archive}/>}
			{user.role === 'exhibitor' && <HomeExhibitor user={user} archive={archive}/>}
		</div>
	);
};

export default HomeUser;
